import {
  CalendarDayPriceResult,
  DayPackagePriceResult,
  GetPaymentStatusQueryResult,
  ICreatePaymentIntentCommandResult,
} from "@repo/rq-api-public";
import { atom } from "jotai";
import { CustomerDetails, PaymentOption } from "./types";

export const listingGuidAtom = atom<string | null>(null);
export const passengersAtom = atom<number>(1);
export const customerDetailsAtom = atom<CustomerDetails | null>(null);

export const currentCalendarMonthDateAtom = atom<Date>(new Date());
export const selectedDateAtom = atom<Date>(new Date());

export const selectedPackageAtom = atom<DayPackagePriceResult | null>(null);
export const selectedSeasonAtom = atom<CalendarDayPriceResult | null>(null);

export const orderDataAtom = atom<
  | ({
      bookingGuid?: string;
      paymentGuid?: string;
      sessionGuid?: string;
      merchantId?: string;
      amount?: number;
      currency?: string;
      checkoutSessionUrl?: string;
    } & ICreatePaymentIntentCommandResult)
  | null
>(null);

export const promoCodeAtom = atom<{
  submittedCode: string | null;
  isLoading?: boolean;
  error?: string;
} | null>(null);

export const orderStatusAtom = atom<
  "PAYMENT_FAILED" | "SUCCESS" | "PENDING" | "SLOT_BOOKED" | null
>(null);

export const isPaymentSubmittingAtom = atom<boolean>(false);

export const isOrderCreatingAtom = atom<boolean>(false);

export const paymentResponseAtom = atom<GetPaymentStatusQueryResult | null>(
  null,
);

export const isGroupPricingPackagesAtom = atom<boolean>(false);
export const filterPricingGuidAtom = atom<string | null>(null);

export const campaignCodeAtom = atom<string | null>(null);

export const campaignValidationAtom = atom<{
  isValid: boolean | null; // null = not yet validated, true = valid, false = invalid
  isLoading: boolean;
  discountAmount?: number;
  error?: string;
}>({
  isValid: null,
  isLoading: false,
});

export const campaignApplicationResultAtom = atom<"success" | "failed" | null>(
  null,
);

export const currentStepAtom = atom<1 | 2 | 3>(1);

export const paymentOptionAtom = atom(PaymentOption.Full);

export const fbpAtom = atom<string | null>(null);
export const fbcAtom = atom<string | null>(null);
export const gaClientIdAtom = atom<string | null>(null);
export const gclidAtom = atom<string | null>(null);
